import { LinkedCompany } from "@/features/modules/company/objects/LinkedCompany";
import { Invoice } from "@/features/modules/invoice/objects/Invoice";

export class CompanyInvoiceYear {
  public company: LinkedCompany | undefined = undefined;
  public year = 0;
  public invoices: Invoice[] = [];
  public total = 0;
}
